export default {
  data() {
    return {
      showCustomInstructorModal: false,
      newCustomInstructor: {
        firstname: '',
        lastname: '',
        email: '',
      },
      customInstructors: [],
      instructorKey: 0,
    };
  },

  methods: {
    /**
     * Retrieve a single course by id.
     * @param {Number} courseId
     * @return {Promise<Course>} Course
     */
    getCourse(courseId) {
      return new Promise(async (resolve, reject) => {
        this.axios
          .get(`course/${courseId}`)
          .then((response) => {
            const course = response.data.course;
            // Map target ids
            course.targets = course.targets.map(target => target.id);
            // If image is null, set empty name, location
            course.meta.og.image = course.meta.og.image || { name: '', location: '' };
            // If location is null, set empty name, location
            course.location = course.location || { name: '', location: '' };
            // If certificate is null, set empty name, location
            course.certificate = course.certificate || { name: '', id: null };

            const mergedInstructors = course.external_instructors.map(instructor => ({
              name: `${instructor.firstname} ${instructor.lastname}`,
              value: 'external',
              id: instructor.id,
            }));

            course.instructors = [...course.instructors, ...mergedInstructors];
            this.customInstructors = course.external_instructors;
            resolve(course);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Delete a single course by id.
     * @param {Number} courseId
     * @return {Promise<Course>} Course
     */
    deleteCourse(courseId) {
      return this.axios
        .delete(`course/${courseId}`);
    },

    /**
     * Retrieve a single location by id.
     * @param {Number} locationId
     * @return {Promise<Location>} Location
     */
    getCourseLocation(locationId) {
      return new Promise(async (resolve, reject) => {
        this.axios
          .get(`location/${locationId}`)
          .then((response) => {
            resolve(response.data.location);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Delete a single location by id.
     * @param {Number} locationId
     * @return {Promise<Location>} Location
     */
    deleteLocation(locationId) {
      return this.axios
        .delete(`location/${locationId}`);
    },

    /**
     * Delete a single planning by id.
     * @param {Number} planningId
     * @return {Promise<Planning>} Planning
     */
    deletePlanning(planningId) {
      return this.axios
        .delete(`planning/${planningId}`);
    },

    promptCustomInstructor(data) {
      this.newCustomInstructor = {
        firstname: data.value.split(' ')[0],
        lastname: data.value.split(' ').slice(1).join(' '),
        email: '',
      };
      this.showCustomInstructorModal = true;
    },

    addCustomInstructor() {
      this.$v.$touch();
      if (this.$v.newCustomInstructor.$anyError) {
        return;
      }
      this.customInstructors.push(this.newCustomInstructor);
      this.data.instructors.push({ name: `${this.newCustomInstructor.firstname} ${this.newCustomInstructor.lastname}`, value: 'exetrnal' });
      this.instructorKey += 1;
      this.showCustomInstructorModal = false;
    },

    removeExternalInstructor(data) {
      this.customInstructors = this.customInstructors
        .filter(instructor => data.id !== instructor.id)
        .filter(instructor => data.label !== `${instructor.firstname} ${instructor.lastname}`);
    },

  },
};
